export const deleteReactionResponse = () => ({
  deleteReaction: {
    status: true,
    __typename: 'Status',
  },
});
